import React from "react";
import {
  CameraContext,
  FlexCameraSummary,
  FlexPreset,
  FlexScheduleSummary,
} from "./types";
import { FlexIgnoreZonesCameraPresetCard } from "./FlexIgnoreZonesCameraPresetCard";
import { FlexPresetConflict } from "./flexPresetConflicts";
import { FlexPresetConflictsNotice } from "./FlexPresetConflictsNotice";

interface SummaryAssignment {
  schedule: FlexScheduleSummary;
  camera: FlexCameraSummary;
  preset: FlexPreset;
  cameraContext?: CameraContext;
}

export const SummaryStep = ({
  assignments,
  conflicts = [],
}: {
  assignments: SummaryAssignment[];
  conflicts?: FlexPresetConflict[];
}) => {
  const grouped = assignments.reduce((acc, assignment) => {
    const scheduleId = assignment.schedule.id;
    if (!acc[scheduleId]) {
      acc[scheduleId] = {
        schedule: assignment.schedule,
        rows: [],
      };
    }
    acc[scheduleId].rows.push(assignment);
    return acc;
  }, {} as Record<number, { schedule: FlexScheduleSummary; rows: SummaryAssignment[] }>);

  return (
    <div className="pr-[8px]">
      <p className="font-mulish text-[20px] font-black pb-[10px]">
        Flex Ignore Zones Summary
      </p>
      <FlexPresetConflictsNotice conflicts={conflicts} />
      {Object.values(grouped).map((group) => (
        <div
          key={group.schedule.id}
          className="border border-gray-300 bg-gray-200 rounded-[6px] p-[12px] mb-[32px]"
        >
          <p className="font-mulish text-[17px] font-black pb-[10px]">
            {group.schedule.display_name}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-[12px] justify-items-start">
            {group.rows.map((row) => (
              <FlexIgnoreZonesCameraPresetCard
                key={`${row.schedule.id}-${row.camera.id}`}
                scheduleId={row.schedule.id}
                camera={row.camera}
                preset={row.preset}
                cameraContext={row.cameraContext}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
